import React from "react";
import useFetch from "../../../hooks/useFetch";
import { DateCardLoading } from "../../../components/ui/loader/CardLoading";
import PaymentCard from "../../../components/ui/card/PaymentCard";

const AllSummary = ({ title, url }) => {
  const { loading, data } = useFetch(url);

  if (loading) {
    return (
      <div>
        <p className="text-sm font-medium sm:ml-4 lg:text-lg">{title}</p>
        <div className="mt-4 w-full grid gap-5 grid-cols-1 ">
          {[1, 2].map((item) => (
            <DateCardLoading key={item} />
          ))}
        </div>
      </div>
    );
  }

  const { successTransaction, cancelTransaction } = data || {};

  return (
    <div>
      <p className="ml-4 text-sm font-medium lg:text-lg">{title}</p>
      <div className="mt-4 grid grid-cols-1 gap-4">
        <PaymentCard
          name="Total Success"
          length={successTransaction?.length}
          amount={successTransaction?.amount}
        />
        <PaymentCard
          name="Total Declined"
          length={cancelTransaction?.length}
          amount={cancelTransaction?.amount}
        />
      </div>
    </div>
  );
};

export default AllSummary;
